import { z } from "zod";

/**
 * Categories: how a shop groups its shelves.
 *
 * Deliberately flat. A pharmacy sorts by "painkillers", "antibiotics",
 * "baby", "cosmetics" — one level, a dozen or so entries, arranged in the order
 * the owner walks the shop. A tree would be a data model nobody asked for and
 * a navigation problem on a phone.
 */

export const createCategoryRequest = z.object({
  name: z.string().trim().min(1, "Name this category").max(80),
  nameSo: z.string().trim().max(80).nullable().optional(),
  /** The order they appear in, which is usually the order of the shelves. */
  sortOrder: z.number().int().min(0).max(999).optional(),
});

export const updateCategoryRequest = createCategoryRequest.partial();

export const categoryResponse = z.object({
  id: z.string().uuid(),
  name: z.string(),
  nameSo: z.string().nullable(),
  sortOrder: z.number().int(),
  /** So the list can say "empty" before an owner tries to archive one. */
  productCount: z.number().int(),
});

export const categoryListResponse = z.object({
  categories: z.array(categoryResponse),
});

export type CreateCategoryRequest = z.infer<typeof createCategoryRequest>;
export type UpdateCategoryRequest = z.infer<typeof updateCategoryRequest>;
export type CategoryResponse = z.infer<typeof categoryResponse>;
